var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DashboardModal',{ref:"modal",class:_vm.$style['pop-up-info-modal'],attrs:{"width":"500px"},on:{"modal-toggle":_vm.close}},[_c('div',{class:_vm.$style['pop-up-info-modal__content']},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }